
<div class="header-image-wrapper" [dir]="(settings.rtl) ? 'rtl' : 'ltr'">
  <div class="bg" [style.background-image]="bgImage" [class.bg-anime]="bgImageAnimate()"></div>
  <div class="mask"></div>
  <div class="header-image-content flex-col justify-start items-center w-100" [class.offset-bottom]="contentOffsetToTop()" [class.home-page]="isHomePage()"  [style.min-height.px]="contentMinHeight()">
    <div class="header-verbiage flex-col justify-center items-center w-100 mt-7">
      @if (title()) {
        <h1 class="title">{{title()}}</h1>
      }
      @if (desc()) {
        <p class="desc">{{desc()}}</p>
      }
      @if (isHomePage()) {
        <div class="search-section w-60 mt-4">
          @if (showPropertySearch) {
            <app-properties-search-box (searchItemSelected)="onSearchItemSelected($event)"></app-properties-search-box>
          }
        </div>
      }
    </div>
  </div>
</div>
